import React from 'react';
import classnames from 'classnames/bind';
import useWindowSize from '@rooks/use-window-size';

import { withSnapPoint } from '@components/snapping-slider';
import { WagtailImageBackground } from '@components/image';
import RichText from '@components/rich-text';
import QuoteIcon from '@icons/quote';
import { forTabletLandscape, calculateAngle } from '@utils/responsive';
import css from './quote.module.scss';

const styles = classnames.bind(css);

export const Quote = ({ quote, cite, className }) => {
    return (
        <blockquote className={styles('quote-slide__quote', className)}>
            <QuoteIcon className={styles('quote-slide__quote__icon')} />
            <RichText>{quote}</RichText>
            <RichText tag="cite">{cite}</RichText>
        </blockquote>
    );
};

const QuoteSlide = (props) => {
    const { slideRef, backgroundUrl, backgroundImage } = props;
    const backgroundView = !!(backgroundUrl || backgroundImage);
    const { innerWidth, innerHeight } = useWindowSize();
    // Desktop angle
    let angle = 0;
    if (forTabletLandscape(innerWidth)) {
        angle = calculateAngle(0.3 * (Math.min(0.7 * innerWidth) - 15), innerHeight);
        angle = angle + 1;
    }

    return (
        <div ref={slideRef} className={styles('quote-slide')}>
            {backgroundView && (
                <WagtailImageBackground
                    className={styles('quote-slide__background')}
                    backgroundImage={backgroundImage}
                    backgroundUrl={backgroundUrl}
                />
            )}

            <div
                className={styles('quote-slide__quote-container', {
                    'quote-slide__quote-container--image': backgroundView,
                })}
            >
                {backgroundView && <div className={styles('quote-slide__mobile-pattern')} />}
                {backgroundView && (
                    <div
                        className={styles('quote-slide__desktop-pattern')}
                        style={{
                            transform: `rotate(${angle}deg)`,
                        }}
                    />
                )}
                <Quote {...props} />
            </div>

            {!backgroundView && (
                <>
                    <div className={styles('quote-slide__left-shard')} />
                    <div className={styles('quote-slide__right-shard')} />
                </>
            )}
        </div>
    );
};

export default withSnapPoint(QuoteSlide);
